import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "o-flex -flex-gap-sm -flex-space-between -flex-align-center-over-sm u-mb-md" }
const _hoisted_2 = { class: "o-flex -flex-gap-sm -flex-align-center-over-sm o-flex__item" }
const _hoisted_3 = { class: "c-modal-search__input o-flex__item" }
const _hoisted_4 = { class: "o-form-group" }
const _hoisted_5 = { class: "o-input__icon" }
const _hoisted_6 = {
  class: "o-input__icon__button",
  type: "submit"
}
const _hoisted_7 = { class: "c-filter__list o-flex__item" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "c-modal-search__row" }
const _hoisted_11 = {
  id: "test-1",
  class: "c-modal-search__col c-modal-search__accordion"
}
const _hoisted_12 = {
  class: "c-modal-search__accordion__title",
  "data-module": "ClassToggle",
  "data-target": "#test-1",
  "data-class": "is-open"
}
const _hoisted_13 = { class: "c-modal-search__accordion__content o-form-group" }
const _hoisted_14 = { class: "c-modal-search__accordion__content__inner" }
const _hoisted_15 = { class: "c-modal-search__accordion__content__inner__inner o-checkbox__group -col-2" }
const _hoisted_16 = ["name", "id", "value", "onChange", "checked"]
const _hoisted_17 = ["for", "innerHTML"]
const _hoisted_18 = {
  id: "test-2",
  class: "c-modal-search__col c-modal-search__accordion"
}
const _hoisted_19 = {
  class: "c-modal-search__accordion__title",
  "data-module": "ClassToggle",
  "data-target": "#test-2",
  "data-class": "is-open"
}
const _hoisted_20 = { class: "c-modal-search__accordion__content" }
const _hoisted_21 = { class: "c-modal-search__accordion__content__inner" }
const _hoisted_22 = { class: "c-modal-search__accordion__content__inner__inner o-form-group o-checkbox__group -col-1" }
const _hoisted_23 = ["name", "id", "value", "onChange", "checked"]
const _hoisted_24 = ["for", "innerHTML"]
const _hoisted_25 = {
  id: "test-3",
  class: "c-modal-search__col c-modal-search__accordion"
}
const _hoisted_26 = {
  class: "c-modal-search__accordion__title",
  "data-module": "ClassToggle",
  "data-target": "#test-3",
  "data-class": "is-open"
}
const _hoisted_27 = { class: "c-modal-search__accordion__content o-form-group" }
const _hoisted_28 = { class: "c-modal-search__accordion__content__inner" }
const _hoisted_29 = { class: "c-modal-search__accordion__content__inner__inner o-checkbox__group -col-1" }
const _hoisted_30 = ["name", "id", "value", "onChange", "checked"]
const _hoisted_31 = ["for", "innerHTML"]
const _hoisted_32 = { class: "c-modal-search__col" }
const _hoisted_33 = {
  id: "test-4",
  class: "c-modal-search__accordion"
}
const _hoisted_34 = {
  class: "c-modal-search__accordion__title",
  "data-module": "ClassToggle",
  "data-target": "#test-4",
  "data-class": "is-open"
}
const _hoisted_35 = { class: "c-modal-search__accordion__content o-form-group" }
const _hoisted_36 = { class: "c-modal-search__accordion__content__inner" }
const _hoisted_37 = { class: "c-modal-search__accordion__content__inner__inner -reverse-mobile" }
const _hoisted_38 = { class: "c-modal-search__date__parent" }
const _hoisted_39 = { class: "c-modal-search__date" }
const _hoisted_40 = { class: "c-modal-search__date__wrap" }
const _hoisted_41 = { class: "o-form-group o-date__group" }
const _hoisted_42 = { class: "c-modal-search__date__wrap" }
const _hoisted_43 = { class: "o-form-group o-date__group" }
const _hoisted_44 = { class: "o-form-group o-checkbox__group -col-1" }
const _hoisted_45 = { class: "o-checkbox__wrap" }
const _hoisted_46 = ["checked"]
const _hoisted_47 = { class: "o-checkbox__wrap" }
const _hoisted_48 = ["checked"]
const _hoisted_49 = { class: "o-checkbox__wrap" }
const _hoisted_50 = ["checked"]
const _hoisted_51 = { class: "o-flex -flex-align-center-over-sm -flex-space-between -flex-wrap -flex-gap-xs u-mt-sm" }
const _hoisted_52 = { class: "c-modal-search__count" }
const _hoisted_53 = {
  class: "o-button -button-show-results",
  type: "submit",
  "aria-label": "Afficher les résultats"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "c-modal-search__triangle" }, null, -1 /* HOISTED */)),
    _createElementVNode("form", {
      id: "search-modal",
      class: "o-form",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers($event => ($options.setParams(true)), ["prevent"]))
    }, [
      _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "o-subtitle u-mb-xs" }, "Recherche avancée", -1 /* HOISTED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                class: "o-label sr-only",
                for: "search"
              }, "Recherchez par mot.s-clé.s", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.search) = $event)),
                  onKeyup: _cache[1] || (_cache[1] = (...args) => ($options.updateSearch && $options.updateSearch(...args))),
                  class: "o-input",
                  type: "search",
                  id: "search",
                  name: "Recherchez par mot.s-clé.s",
                  placeholder: "Recherchez par mot.s-clé.s"
                }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
                  [_vModelText, $data.search]
                ]),
                _createElementVNode("button", _hoisted_6, [
                  _createVNode(_component_Image, { id: "search" })
                ])
              ])
            ])
          ]),
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.outputFilters(), (tag) => {
              return (_openBlock(), _createElementBlock("li", {
                key: tag.value,
                class: "c-filter__item"
              }, [
                _createElementVNode("button", {
                  class: "c-filter__item__close",
                  onClick: $event => ($options.deleteFilter(tag.type, tag.value))
                }, [
                  _createVNode(_component_Image, { id: "close" })
                ], 8 /* PROPS */, _hoisted_8),
                _createElementVNode("span", {
                  class: "c-filter__item__title",
                  innerHTML: tag.name
                }, null, 8 /* PROPS */, _hoisted_9)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "c-modal-search__reset",
            onClick: _cache[2] || (_cache[2] = (...args) => ($options.resetFilters && $options.resetFilters(...args))),
            type: "button"
          }, " Réinitialiser ")
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "o-subtitle" }, "Catégories", -1 /* HOISTED */)),
            _createVNode(_component_Image, { id: "arrow-down-sm" })
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allCategories, (category) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: category.id,
                    class: "o-checkbox__wrap"
                  }, [
                    _createElementVNode("input", {
                      class: "o-checkbox",
                      type: "checkbox",
                      name: 'category_'+category.slug,
                      id: 'category_'+category.slug,
                      value: category.slug,
                      onChange: $event => ($options.addFilter('categories', category.slug)),
                      checked: $data.selectedCategories.includes(category.slug)
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_16),
                    _createElementVNode("label", {
                      class: "o-checkbox-label",
                      for: 'category_'+category.slug,
                      innerHTML: category.name
                    }, null, 8 /* PROPS */, _hoisted_17)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", _hoisted_19, [
            _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "o-subtitle" }, "Types", -1 /* HOISTED */)),
            _createVNode(_component_Image, { id: "arrow-down-sm" })
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allTypes, (type) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "o-checkbox__wrap",
                    key: type.term_id
                  }, [
                    _createElementVNode("input", {
                      class: "o-checkbox",
                      type: "checkbox",
                      name: 'type_'+type.slug,
                      id: 'type_'+type.slug,
                      value: type.slug,
                      onChange: $event => ($options.addFilter('types', type.slug)),
                      checked: $data.selectedTypes.includes(type.slug)
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_23),
                    _createElementVNode("label", {
                      class: "o-checkbox-label",
                      for: 'type_'+type.slug,
                      innerHTML: type.name
                    }, null, 8 /* PROPS */, _hoisted_24)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", _hoisted_26, [
            _cache[12] || (_cache[12] = _createElementVNode("h2", { class: "o-subtitle" }, "Lieux", -1 /* HOISTED */)),
            _createVNode(_component_Image, { id: "arrow-down-sm" })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allSalles, (place) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "o-checkbox__wrap",
                    key: place.ID
                  }, [
                    _createElementVNode("input", {
                      class: "o-checkbox",
                      type: "checkbox",
                      name: 'place_'+place.post_name,
                      id: 'place_'+place.post_name,
                      value: place.post_name,
                      onChange: $event => ($options.addFilter('salles', place.post_name)),
                      checked: $data.selectedSalles.includes(place.post_name)
                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_30),
                    _createElementVNode("label", {
                      class: "o-checkbox-label",
                      for: 'place_'+place.post_name,
                      innerHTML: place.post_title
                    }, null, 8 /* PROPS */, _hoisted_31)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", _hoisted_34, [
              _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "o-subtitle" }, "Périodes", -1 /* HOISTED */)),
              _createVNode(_component_Image, { id: "arrow-down-sm" })
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "o-date-label" }, "Entre le", -1 /* HOISTED */)),
                        _createElementVNode("div", _hoisted_41, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", {
                            class: "o-label sr-only",
                            for: "starting-date"
                          }, "Date de début", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("input", {
                            class: "o-date",
                            type: "date",
                            id: "starting-date",
                            name: "Date de début",
                            placeholder: "AAAA/MM/JJ",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.dates.start) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.dates.start]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_42, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "o-date-label" }, "Et le", -1 /* HOISTED */)),
                        _createElementVNode("div", _hoisted_43, [
                          _cache[16] || (_cache[16] = _createElementVNode("label", {
                            class: "o-label sr-only",
                            for: "starting-date"
                          }, "Date de début", -1 /* HOISTED */)),
                          _withDirectives(_createElementVNode("input", {
                            class: "o-date",
                            type: "date",
                            id: "starting-date",
                            name: "Date de début",
                            placeholder: "AAAA/MM/JJ",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.dates.end) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelText, $data.dates.end]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _cache[21] || (_cache[21] = _createElementVNode("hr", null, null, -1 /* HOISTED */)),
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("input", {
                        class: "o-checkbox",
                        type: "checkbox",
                        name: "today",
                        id: "today",
                        value: "today",
                        onChange: _cache[5] || (_cache[5] = $event => ($options.toggleDates($options.today))),
                        checked: this.today.start === this.dates.start && this.today.end === this.dates.end
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_46),
                      _cache[18] || (_cache[18] = _createElementVNode("label", {
                        class: "o-checkbox-label",
                        for: "today"
                      }, " Aujourd'hui ", -1 /* HOISTED */))
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("input", {
                        class: "o-checkbox",
                        type: "checkbox",
                        name: "weekend",
                        id: "weekend",
                        value: "weekend",
                        onChange: _cache[6] || (_cache[6] = $event => ($options.toggleDates($options.thisweekend))),
                        checked: this.thisweekend.start === this.dates.start && this.thisweekend.end === this.dates.end
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_48),
                      _cache[19] || (_cache[19] = _createElementVNode("label", {
                        class: "o-checkbox-label",
                        for: "weekend"
                      }, " Ce week-end ", -1 /* HOISTED */))
                    ]),
                    _createElementVNode("div", _hoisted_49, [
                      _createElementVNode("input", {
                        class: "o-checkbox",
                        type: "checkbox",
                        name: "next7",
                        id: "next7",
                        value: "next7",
                        onChange: _cache[7] || (_cache[7] = $event => ($options.toggleDates($options.next7))),
                        checked: this.next7.start === this.dates.start && this.next7.end === this.dates.end
                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_50),
                      _cache[20] || (_cache[20] = _createElementVNode("label", {
                        class: "o-checkbox-label",
                        for: "next7"
                      }, " 7 prochains jours ", -1 /* HOISTED */))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, _toDisplayString($data.totalResults) + " résultats ", 1 /* TEXT */),
            _createElementVNode("div", null, [
              _createElementVNode("button", _hoisted_53, [
                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "o-button__text" }, "Afficher les résultats", -1 /* HOISTED */)),
                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "sr-only" }, "Afficher les résultats", -1 /* HOISTED */)),
                _createVNode(_component_Image, { id: "eye" })
              ])
            ])
          ])
        ])
      ])
    ], 32 /* NEED_HYDRATION */)
  ], 64 /* STABLE_FRAGMENT */))
}